import React from "react";
import EventGalleryPage from "../../components/EventGalleryPage";
import { eventGalleries } from "../../data/galleries";

export default function Womensday() {
  return (
    <EventGalleryPage
      cloudinaryFolder="images/womensday"
      imageLabel="Women's Day"
      images={eventGalleries.womensday}
      intro={{
        icon: "👩‍🦰👩‍🦳👩‍⚕️👩‍🏫",
        title: "Celebrating Women – Grace, Strength, and Endless Inspiration",
        subtitle: (
          <>
            <p>From vibrant decor to unforgettable moments, let Fiesta Event Decor help you honor the incredible women in your life.</p>
            <p className="mt-4">Whether you're planning a Women's Day brunch, recognition ceremony, or community event — we’re here to make it beautiful, bold, and meaningful.</p>
          </>
        ),
      }}
    />
  );
}
